import React, { useState } from "react";
import SubProjectItem from "./SubProjectItem/SubProjectItem";
import { getOneProjectFiles, getOneProjectLinks, cancelSubscription } from "../../../../services/projects";
import LinkItem from "./SubProjectItem/LinkItem";
import "../ProjectsFiles.scss";

const ProjectsFiles = ({ project, activeProjects, token, setSubscriptionCancel, refreshProjects }) => {
    const [projectLinksCache, setProjectLinksCache] = useState({});
    const [projectFilesCache, setProjectFilesCache] = useState({});
    const [active, setActive] = useState(false);
    const [canceling, setCanceling] = useState(false);
    const img = project.cover;

    const getProjectFiles = async (token, id) => {
        try {
            return await getOneProjectFiles({
                token: token,
                id: id
            });
        } catch (error) {
            console.error('Error fetching project files:', error);
        }
    };

    const getProjectLinks = async (token, id) => {
        try {
            return await getOneProjectLinks({
                token: token,
                id: id
            });
        } catch (error) {
            console.error('Error fetching project links:', error);
        }
    };

    const handleButtonClick = async (token, projectId) => {
        let projectFiles = projectFilesCache[projectId];
        if (!projectFiles) {
            projectFiles = await getProjectFiles(token, projectId);
            setProjectFilesCache(prevCache => ({ ...prevCache, [projectId]: projectFiles }));
        }

        let projectLinks = projectLinksCache[projectId];
        if (!projectLinks) {
            projectLinks = await getProjectLinks(token, projectId);
            setProjectLinksCache(prevCache => ({ ...prevCache, [projectId]: projectLinks }));
        }

        setActive(prevActive => !prevActive);
    };

    const handleCancelSubscription = async () => {
        const userInput = prompt("Please type CANCEL to confirm that you want to cancel this subscription.");
        if (userInput) {
            if (userInput.toLowerCase() === "cancel") {
                setCanceling(true);
                try {
                    const subscriptionResponse = await cancelSubscription({
                        id: project.subscription?.id || "",
                        isFree: project.free,
                        projectId: project.id,
                    });
                    if (subscriptionResponse.error) {
                        setSubscriptionCancel(subscriptionResponse.error);
                    } else {
                        refreshProjects();
                    }
                } catch (error) {
                    setSubscriptionCancel('Error cancelling subscription:' + error);
                } finally {
                    setCanceling(false);
                }
            }
        }
    };

    const projectFiles = projectFilesCache[project.id];
    const projectLinks = projectLinksCache[project.id];

    return (
        <>
            <h4 className="panel-title">
                <button onClick={() => handleButtonClick(token, project.id)}>
                    <span className="panel-img"><img src={img} alt={project.id} /> </span>
                    <span className="panel-text"> {project.name} </span>
                </button>
                {activeProjects === 'subscriptions' && (
                    <button
                        onClick={handleCancelSubscription}
                        className={`btn ${canceling ? 'canceling' : ''}`}
                        disabled={canceling}
                    >
                        {canceling ? 'Please wait...' : 'Cancel'}
                    </button>
                )}
            </h4>
            <div className={`collapse-file-list ${active ? 'active' : ''}`}>
                {projectFiles && projectFiles.map((projectFile) => (
                    <SubProjectItem key={projectFile.id} projectFile={projectFile} />
                ))}

                {projectLinks && projectLinks.map((projectLink, index) => (
                    <LinkItem key={index} projectLink={projectLink} />
                ))}
            </div>
        </>
    );
}

export default ProjectsFiles;
